import React from "react";
import { ReactComponent as Logo } from "./operator.svg";
import SvgIcon from "@material-ui/core/SvgIcon";

import "../Icons.scss";

const OperatorIcon = (props) => {
  const { iconClass } = props;
  return (
    <SvgIcon className={iconClass} component={Logo} viewBox="0 0 512 512" />
  );
};

export default OperatorIcon;
